<app-dialog
    [dialogWithInput]="dialog">
    <app-video-recorder (recordedEvent)="dialog.close({blob: $event})"></app-video-recorder>
</app-dialog>